import { SwapOutlined } from '@ant-design/icons';
import { CaseUtil } from '@vectord/utils';
import { type NodeProps, Position } from '@xyflow/react';
import CompareNodeMenu from 'automations/components/Nodes/CompareNodeMenu';
import { type CompareNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ConditionNodeReturnProps } from './useConditionNodeConfig';

export const DEFAULT_HANDLE_ID = 'default';

export default function useCompare(node: NodeProps<CompareNodeType>): ConditionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.CompareNodeData, node.data), [node.data]);
  const AdditionalUi = useMemo(() => <CompareNodeMenu node={node} />, [node]);

  const subTitle = useMemo(() => {
    const compareData = node.data?.additionalOptions?.compare;
    if (!compareData) return null;

    return compareData.criterias.reduce((text, criteria, index) => {
      const parsedComparator = CaseUtil.toCase('titleCase', criteria.comparator);
      const condition = `${criteria.conditionKey} ${parsedComparator} ${criteria.conditionValue}`;
      if (index === compareData.criterias.length - 1) {
        return `${text} ${condition}`;
      }
      return `${text} ${condition} ${compareData.comparator} `;
    }, '');
  }, [node.data?.additionalOptions?.compare]);

  return {
    icon: SwapOutlined,
    subTitle,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    targetHandle: {
      type: 'target',
      position: Position.Bottom,
      id: DEFAULT_HANDLE_ID,
    },
    AdditionalUI: AdditionalUi,
  };
}
